import { z } from 'zod';
import { createToolSignature, ToolSignature } from './tool-signature';

export const displayPlaybooksToolSignature = createToolSignature({
    name: 'displayPlaybooksTool',
    description: 'Display a selection of playbooks to the user.',
    inputSchema: z.object({
        groupIds: z.array(z.string()).describe('The groupIds of the playbooks to display'),
    }),
    outputSchema: z.object({
        groupIds: z.array(z.string()).describe('The groupIds of the playbooks to display'),
    }),
    toolCallUi: (input) => null,
});
